import { useReducer } from 'react';
import { connect } from 'react-redux';

import { LocalizedCurrencyValue } from '@mews-distributor/common';
import { rateCompareFactory, type RateCompareProps } from '@mews-distributor/ui';

import { getCurrentDateSelectedEnterpriseLowestPrice } from '../../modules/pricing/views/enterprisesPricing';
import { ApplicationState } from '../../types';
import { inject } from '../common/Price/inject';
import { adjustCurrencyValueByPercentage } from './currencyValue';
import { getCompetitorPriceRelativeAdjustment, getCompetitors, getRateDescription } from './selectors';

const MewsRateCompare = rateCompareFactory({
    Price: inject(LocalizedCurrencyValue),
});

const mapState = (state: ApplicationState) => {
    const lowestRoomPrice = getCurrentDateSelectedEnterpriseLowestPrice(state, {});
    const priceAdjustment = getCompetitorPriceRelativeAdjustment(state) ?? 0;
    const competitorsPrice = adjustCurrencyValueByPercentage(lowestRoomPrice, priceAdjustment);

    return {
        lowestRoomPrice,
        priceAdjustment,
        competitorsPrice,
        competitors: getCompetitors(state),
        description: getRateDescription(state),
    };
};

type StateProps = ReturnType<typeof mapState>;
type BaseRateCompareContainerProps = StateProps & Omit<RateCompareProps, keyof StateProps | 'opened' | 'toggleOpened'>;

const BaseRateCompareContainer = ({
    competitors,
    lowestRoomPrice,
    description,
    priceAdjustment,
    competitorsPrice,
    ...other
}: BaseRateCompareContainerProps) => {
    const [opened, toggleOpened] = useReducer((a: boolean) => !a, true);

    return (
        <MewsRateCompare
            competitors={competitors}
            competitorsPrice={competitorsPrice}
            description={description}
            lowestRoomPrice={lowestRoomPrice}
            priceAdjustment={priceAdjustment}
            opened={opened}
            toggleOpened={toggleOpened}
            {...other}
        />
    );
};

export const RateCompareContainer = connect(mapState)(BaseRateCompareContainer);
